import React from 'react';
import DatePicker from '../../../../../../src/components/Fields/DatePicker';
import Translate from '../../../../../../src/components/Translate/Translate';
import classnames from '../../../../../../src/helpers/classnames';
import {Controller, useFormContext} from 'react-hook-form';
import FormErrorMessage from '../../../../../../src/components/Form/FormErrorMessage';

export default function WillChangeAtField({isDisabled}: {
    formId: string,
    isDisabled?: boolean,
}) {
    const {control} = useFormContext();

    return <Controller
            name="payload.will_change_at"
            control={control}
            render={(
                    {
                        field: {value, onChange},
                        fieldState: {error}
                    }
            ) => {
                return <div>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.change-status.fields.will_change_at"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <DatePicker
                            label="TaskForm.change-status.fields.will_change_at"
                            size="sm"
                            className={classnames({'is-invalid': error})}
                            isInvalid={Boolean(error)}
                            value={value}
                            onChange={onChange}
                            disabled={isDisabled}
                            dateFormat="Pp"
                            showTimeInput={true}
                            showTimeSelect={true}
                    />

                    <FormErrorMessage fieldName="payload.will_change_at"/>
                </div>;
            }}
    />;
}
